export default __webpack_public_path__ + "static/media/stars_background.13058e5d.png";